<div class="modal-header">
  <!-- p-0 py-2 px-3 -->
  <h3 class="pageheader">
    <i class="ti ti-settings fs-3" style="font-size: 16px !important"></i>&nbsp;
    Profile Settings
  </h3>
  <button
    type="button"
    class="btn-close"
    (click)="closeModal()"
    aria-label="Close"
  ></button>
</div>
<div class="modal-body" [formGroup]="ProfileSettingForm">
  <app-input-field
    label="First Name"
    placeholder="First Name"
    type="text"
    [isRequired]="true"
    [formGroup]="ProfileSettingForm"
    formName="firstname"
    formControlValue="firstname"
    [errorMessages]="{
      required: 'First Name is required',
    }"
  />
  <app-input-field
    label="Last Name"
    placeholder="Last Name"
    type="text"
    [isRequired]="true"
    [formGroup]="ProfileSettingForm"
    formName="lastname"
    formControlValue="lastname"
    [errorMessages]="{
      required: 'Last Name is required',
    }"
  />
  <app-input-field
    label="Email Address"
    placeholder="Email Address"
    type="email"
    [isRequired]="true"
    [formGroup]="ProfileSettingForm"
    formName="email"
    formControlValue="email"
    [errorMessages]="{
      required: 'Email is required',
      pattern: 'Email pattern is wrong',
      invalid: 'Email is invalid',
    }"
  />
  <div class="row">
    <app-multiple-file-uploader
      label=""
      [formGroup]="ProfileSettingForm"
      formControlValue="logo"
      formName="logo"
      [acceptFileType]="'.jpg,.jpeg,.png'" 
      [uploaderHeading]="'Upload Profile Picture'"
      [hintText]="'Accepted file types: JPEG, PNG (File Size max 2MB)'"
      (onSelectFile)="onLogoChange($event)"
      (onRemoveFile)="onLogoRemove()"
    />
    <!-- <div class="col-4 ">
    <img
    src="assets/images/users/avatar-1.jpg"
    width="80"
    class="rounded-circle  d-flex profileimage"
    alt="user-image"
  />
</div> -->
  </div>
  <div class="py-3">
    <button
      class="btn btn-lg w-100 btnForgetPassword"
      type="submit"
      (click)="onSubmit()"
    >
      Update
    </button>
  </div>
</div>
